// import logo from "../assets/images/Placeholder.png"
import placeholder from "../../assets/images/Placeholder.png"
import galleryOverview from "../../assets/images/gallery-overview.png"
import characterIllustration1 from "../../assets/images/character-illustration-1.jpg"
import characterIllustration2 from "../../assets/images/character-illustration-2.jpg"
import characterIllustration3 from "../../assets/images/character-illustration-3.jpg"
import characterIllustration4 from "../../assets/images/character-illustration-4.jpg"
import characterIllustration5 from "../../assets/images/character-illustration-5.jpg"
import characterIllustration6 from "../../assets/images/character-illustration-6.jpg"
import characterIllustrationA from "../../assets/images/character-illustration-a.jpg"
import characterIllustrationB from "../../assets/images/character-illustration-b.jpg"


export const imageFiles = {
    placeholder,
    galleryOverview,
    characterIllustration1,
    characterIllustration2,
    characterIllustration3,
    characterIllustration4,
    characterIllustration5,
    characterIllustration6,
    characterIllustrationA,
    characterIllustrationB,
}
